import React,{useState,useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Component} from "react-router-dom";
// import { useisLoggedIn } from './components/SharedHooks';
import LoginPage from './components/LoginPage';

const PrivateRoute = ({children, ...rest}) => {
  if (process.env.PREVIEW_CAPTURE_BUILD === 'true' || (typeof window !== 'undefined' && window.__PREVIEW_BYPASS)) {
    return <Route {...rest}>{children}</Route>;
  }
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isFetchDone, setIsFetchDone] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsFetchDone(true);
      setIsLoggedIn(false);
      return;
    }
    const baseUrl = typeof window !== 'undefined' && window.SERVER_URL ? window.SERVER_URL : '';
    if (!baseUrl) {
      setIsLoggedIn(false);
      setIsFetchDone(true);
      return;
    }
    let cancelled = false;
    const verifyToken = async (token) => {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 15000);
        const res = await fetch(baseUrl + "/a/verify", {
          headers: {
            Authorization: "Bearer " + token,
          },
          signal: controller.signal,
        });
        clearTimeout(timeoutId);
        if (cancelled) return;
        const data = await res.json();
        if (data.status === 'success' || data.valid === true) {
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
        }
        setIsFetchDone(true);
      } catch (e) {
        if (!cancelled) {
          setIsLoggedIn(false);
          setIsFetchDone(true);
        }
      }
    };
    verifyToken(token);
    return () => { cancelled = true; };
  }, []);
  return (
    <Route {...rest}>
      {!isFetchDone ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', fontFamily: 'sans-serif' }}>
          Loading…
        </div>
      ) : isLoggedIn ? (
        children
      ) : (
        <Redirect to="/login" />
      )}
    </Route>
  );
}


export default PrivateRoute;

